export const projects = [
  {
    title: "Next-Gen Multi-Cloud Data Lake",
    front: {
      summary: "Unified governance and analytics across AWS and Azure with Databricks Lakehouse.",
      stack: ["Delta Lake", "Databricks", "Unity Catalog", "Terraform"]
    },
    back: {
      details: [
        "Designed hybrid governance across AWS (S3) and Azure (ADLS) using Unity Catalog and Delta Lake.",
        "Automated schema registration, access policies, and optimization jobs (OPTIMIZE, Z-ORDER, VACUUM).",
        "Integrated Terraform for provisioning and role-based cross-workspace access."
      ],
      link: ""
    }
  },
  {
    title: "DataHauler Platform",
    front: {
      summary: "Custom Spark–Scala ingestion framework for multi-domain telemetry data.",
      stack: ["Spark", "Scala", "Delta Lake", "Terraform", "Argo"]
    },
    back: {
      details: [
        "Built modular ingestion pipelines for telemetry data collected from 6 Million devices.",
        "Implemented anonymization, flattening, and dynamic schema evolution for nested JSON.",
        "Automated Delta registration and optimization workflows, reducing manual ops by 60%."
      ],
      link: ""
    }
  },
  {
    title: "NATS ⇄ Spark Connector",
    front: {
      summary: "High-throughput JetStream → Spark connector for streaming telemetry data.",
      stack: ["Scala", "NATS JetStream", "Spark Streaming", "Kubernetes"]
    },
    back: {
      details: [
        "Engineered custom connector for NATS JetStream → Spark ingestion with offset checkpointing.",
        "Optimized deserialization and batching to handle complex event payloads.",
        "Achieved sustained throughput of 120K events/sec in internal benchmarks."
      ],
      link: ""
    }
  },
  {
    title: "Cyber Resilience Risk Index",
    front: {
      summary: "Telemetry-powered analytics framework for Absolute’s 2025 Resilience Index.",
      stack: ["Databricks", "Delta Lake", "Governance", "Analytics"]
    },
    back: {
      details: [
        "Developed telemetry pipelines driving metrics for the Resilience Risk Index 2025 report.",
        "Integrated ingestion, normalization, scoring, and analytics publishing pipelines.",
        "Enabled secure Delta Sharing for partner collaboration and automated data refresh."
      ],
      link: "https://www.absolute.com/resources/research-reports/resilience-risk-index-2025"
    }
  },
  {
    title: "Solar Sustainability App",
    front: {
      summary: "Award-winning mobile app promoting solar awareness and renewable energy.",
      stack: ["Java", "HTML5", "JavaScript", "CSS", "Tizen SDK"]
    },
    back: {
      details: [
        "Developed a cross-platform Tizen/web app promoting solar adoption and sustainability.",
        "Built real-time calculators for energy load, cost estimation, and inverter sizing.",
        "Integrated REST APIs and responsive dashboards tracking energy generation and CO₂ offset."
      ],
      link: ""
    }
  }
];
